<div class="wrapper" *ngIf="display">
  <div class="wrapper__header">
    <app-home-header></app-home-header>
  </div>
  <div class="wrapper__content">
    <router-outlet></router-outlet>
  </div>
</div>
